const topics = 
[
{
    "id": "1",
    "topics_name": "Нэр томъёо ба тодорхойлолт",
    "question_number": "20"
},
{
    "id": "2",
    "topics_name": "Механикжсан тээврийн хэрэгслийн ангилал",
    "question_number": "20"
},
{
    "id": "3",
    "topics_name": "Жолоочийн үүрэг",
    "question_number": "30"
},
{
    "id": "4",
    "topics_name": "Тусгай дуут болон гэрлэн дохио ажиллулсан тээврийн хэрэгслийн хөдөлгөөн",
    "question_number": "10"
},
{
    "id": "5",
    "topics_name": "Замын тэмдэг",
    "question_number": "120"
},
{
    "id": "6",
    "topics_name": "Замын тэмдэглэл",
    "question_number": "40"
},
{
    "id": "7",
    "topics_name": "Замын хөдөлгөөн зохицуулах дохио",
    "question_number": "40"
},
{
    "id": "8",
    "topics_name": "Анхааруулах дохио ба таних тэмдэг",
    "question_number": "40"
},
{
    "id": "9",
    "topics_name": "Хөдөлгөөн эхлэх болон чиг өөрчлөх",
    "question_number": "80"
},
{
    "id": "10",
    "topics_name": "Тээврийн хэрэгсэл байрлан явах",
    "question_number": "80"
},
{
    "id": "11",
    "topics_name": "Тээврийн хэрэгслийн хурд",
    "question_number": "20"
},
{
    "id": "12",
    "topics_name": "Гүйцэж түрүүлэх ба гүйцэх",
    "question_number": "20"
},
{
    "id": "13",
    "topics_name": "Түр ба удаан зогсох",
    "question_number": "80"
},
{
    "id": "14",
    "topics_name": "Уулзвар нэвтрэх",
    "question_number": "70"
},
{
    "id": "15",
    "topics_name": "Явган хүний гарц нэвтрэх",
    "question_number": "10"
},
{
    "id": "16",
    "topics_name": "Төмөр замын гарам нэвтрэх",
    "question_number": "20"
},
{
    "id": "17",
    "topics_name": "Гадна талын гэрэлтүүлэх хэрэгслийг хэрэглэх",
    "question_number": "10"
},
{
    "id": "18",
    "topics_name": "Хорооллын доторх хөдөлгөөн",
    "question_number": "10"
},
{
    "id": "19",
    "topics_name": "Тууш замын хөдөлгөөн",
    "question_number": "10"
},
{
    "id": "20",
    "topics_name": "Механикжсан тээврийн хэрэгслийг чирэх",
    "question_number": "10"
},
{
    "id": "21",
    "topics_name": "Хүн ба ачаа тээвэрлэх",
    "question_number": "20"
},
{
    "id": "22",
    "topics_name": "Тээврийн хэрэгслийн эвдрэл гэмтэл, техникийн зөрчил",
    "question_number": "20"
},
{
    "id": "23",
    "topics_name": "Тээврийн хэрэгслийг аюулгүй жолоодох онол",
    "question_number": "10"
},
{
    "id": "24",
    "topics_name": "Эмнэлгийн анхны тусламж",
    "question_number": "10"
}
]

export default topics